import * as React from 'react';
import { MainStoreConsumer } from '../../../../stores/MainStore';
import styles from '../../Elements.module.scss';
import { RequestType } from '../../../../interfaces/RequestType';
import TextFieldInput from '../../../inputs/TextFieldInput';
import { IFormPageInputsProps } from './IFormPageInputsProps';
import DropdownFieldInput from '../../../inputs/DropdownFieldInput';

export default class FormPageInputs extends React.Component<IFormPageInputsProps> {
  public render(): JSX.Element {
    const { disabled } = this.props;

    return (
      <MainStoreConsumer>
        {(store) => {
          const requestType = store.inputs.inputValues['RequestType'].value;
          const requestPurposeLabel =
            requestType === RequestType.sponsoring ? 'Step2_Purpose_Sponsorships' : 'Steps2_Purpose_Donation';

          return (
            <div className={styles.fields}>
              <TextFieldInput
                label={requestPurposeLabel}
                internalName='RequestPurpose'
                multiline={true}
                disabled={disabled}
              />

              {requestType === RequestType.sponsoring && (
                <TextFieldInput
                  label='Step2-1_Sponsoring_Compensation'
                  internalName='RequestSponsoringCompensation'
                  multiline={true}
                  disabled={disabled}
                />
              )}

              {requestType === RequestType.sponsoring && (
                <TextFieldInput
                  label='Step2_Sponsorship_History_Value'
                  internalName='SponsorshipHistory'
                  multiline={true}
                  disabled={disabled}
                />
              )}

              {requestType === RequestType.donation && (
                <>
                  <TextFieldInput
                    label='Step2_Donation_Reference'
                    internalName='DonationReference'
                    multiline={true}
                    disabled={disabled}
                  />

                  <TextFieldInput
                    label='Step2_Donation_History'
                    internalName='DonationHistory'
                    multiline={true}
                    disabled={disabled}
                  />
                </>
              )}

              <TextFieldInput label='Step2_Money_Value' internalName='RequestMoney' disabled={disabled} />

              {requestType === RequestType.donation && (
                <DropdownFieldInput
                  label='Step2_Donation_Own_Budget'
                  internalName='OwnBudget'
                  options={[{ name: store.translation.t('Yes') }, { name: store.translation.t('No') }]}
                  disabled={disabled}
                />
              )}
            </div>
          );
        }}
      </MainStoreConsumer>
    );
  }
}
